import { useCallback, useEffect, useState } from 'react';
import { Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import { CouponServiceV2 } from '../../services/CuponServiceV2';
import moment from 'moment';

interface InputProps {
    houseId: number;
}

const couponServiceV2 = new CouponServiceV2();

const HousesCouponTab = ({ houseId }: InputProps) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        couponServiceV2
            .getAllCouponForHouseV2(houseId)
            .then((res) => {
                setData(res?.data ?? []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [houseId]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    const columns: CommonListColumn[] = [
        {
            label: 'Id',
            render: (row) => (
                <Link href={`/#/CouponsV2/${row?.id}/show`} underline="hover">
                    {row?.id || 'Not Available'}
                </Link>
            ),
        },
        { label: 'Coupon Code', field: 'couponCode' },
        { label: 'Coupon Value', field: 'couponValue' },
        {
            label: 'Status',
            render: (row) => (!row?.isActive || moment(row?.expiresAt).isBefore(moment())) ? (
                <b style={{ color: 'red' }}>Expired</b>
            ) : (
                <b style={{ color: 'green' }}>Active</b>
            ),
        },
        { label: 'Product Type', field: 'productType' },
        { label: 'Coupon Type', field: 'couponType' },
        { label: 'Max Discount Amount', field: 'maximumDiscountAmount' },
        { label: 'Max Usage Limit', field: 'maximumUsageLimit' },
        { label: 'Min Order Value', field: 'minimumOrderValue' },
        { label: 'Coupon Header', field: 'couponHeader' },
        { label: 'Coupon Description', field: 'couponDescription' },
        { label: 'Created At', field: 'createdAt', type: 'datetime' },
        { label: 'Expires At', field: 'expiresAt', type: 'datetime' },
    ];

    return (
        <CommonListTable
            columns={columns}
            data={data}
            loading={loading}
            emptyText="No Coupon Found"
        />
    );
};

export default HousesCouponTab;
